import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CTASection = ({ onTrial, onLogin }) => {
  return (
    <section className="relative py-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl border border-cyan-500/30 bg-gradient-to-br from-cyan-950/50 via-[#0D1424] to-violet-950/40 px-6 py-14 text-center sm:px-12 lg:py-20"
          data-testid="cta-section"
        >
          <div className="pointer-events-none absolute left-1/2 top-0 h-80 w-[600px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(0,240,255,0.15)_0%,transparent_70%)]" />
          <div className="relative">
            <h2 className="mx-auto max-w-2xl font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Siap Membawa Sekolah Anda ke Era Digital?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-slate-300">
              Bergabung dengan sekolah-sekolah yang telah memodernisasi administrasinya. Coba gratis 14 hari, tanpa risiko.
            </p>
            <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
              <Button
                size="lg"
                onClick={() => onTrial()}
                data-testid="cta-trial-btn"
                className="group h-12 bg-gradient-to-r from-cyan-400 to-violet-600 px-7 text-base font-semibold text-[#060A12] hover:shadow-[0_0_28px_rgba(0,240,255,0.45)]"
              >
                Daftarkan Sekolah Saya
                <ArrowRight className="ml-1 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={onLogin}
                data-testid="cta-login-btn"
                className="h-12 border-cyan-500/30 bg-transparent px-7 text-base font-semibold text-slate-100 hover:border-cyan-400/60 hover:bg-cyan-500/10"
              >
                Login ke Sekolah Saya
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
